export default __webpack_public_path__ + "static/media/checkmark.9a4e7e75.svg";